import styled from 'styled-components';
import { space } from 'styled-system';
import Wrapper from '../Wrapper';

const Container = styled(Wrapper)`
  max-width: ${({ fluid, theme }) =>
    fluid ? 'inherit' : `${theme.containerMaxWidth}px`};
  ${space};
`;

Container.defaultProps = {
  width: 'calc(100% - 32px)',
  margin: '0 auto',
  padding: '0 16px',
};

export default Container;
